export const DATADOG_APPLICATION_ID = '9b982287-5038-4302-b17f-4c953bd1c78f';
export const DATADOG_CLIENT_TOKEN = 'pub40efb97f8043847dc1d7be911b581b91';
export const DATADOG_SAMPLE_RATE = 100;
export const DATADOG_SITE = 'datadoghq.com';
